import { mobileModeEnabledSelector } from 'selectors/persistedUiSelectors';
import { useMediaQuery } from '@material-ui/core';
import { useSelector } from 'react-redux';

/**
 * Returns true if the UI is in mobile mode.
 * Mobile mode is a combination of screen size AND user preference.
 * A user can opt out of mobile mode which will force the screen to display outside of
 * small screen breakpoints using meta tag manipulation.
 *
 * @see resizeCallback in responsive.ts for more details
 */
export const useIsInMobileMode = () => {
  const isMobileModeEnabled = useSelector(mobileModeEnabledSelector);
  const isAtMobileScreenSize = useMediaQuery('(max-width:479px)');

  return isMobileModeEnabled && isAtMobileScreenSize;
};
